// import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'

// import dates  from 'react-big-calendar/lib/utils'
import * as dates from 'react-big-calendar/lib/utils/dates'
import { navigate } from 'react-big-calendar/lib/utils/constants'
import { Views } from 'react-big-calendar'
import './years.css'

function createCalendar(currentDate) {
  if (!currentDate) {
    currentDate = moment()
  } else {
    currentDate = moment(currentDate)
  }

  const first = currentDate.clone().startOf('month')
  const last = currentDate.clone().endOf('month')
  const weeksCount = Math.ceil((first.day() + last.date()) / 7)
  const calendar = Object.assign([], { currentDate, first, last })

  for (let weekNumber = 0; weekNumber < weeksCount; weekNumber++) {
    const week = []
    calendar.push(week)
    calendar.year = currentDate.year()
    calendar.month = currentDate.month()

    for (let day = 7 * weekNumber; day < 7 * (weekNumber + 1); day++) {
      const date = currentDate.clone().set('date', day + 1 - first.day())
      date.calendar = calendar
      week.push(date)
    }
  }

  return calendar
}

function CalendarDate(props) {
  const datesWithEvents = props.events.map(ev => moment(ev.start).format('YYYY-MM-DD'));
  const { dateToRender, dateOfMonth } = props
  const today =
    dateToRender.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
      ? 'today'
      : ''

  if (dateToRender.month() < dateOfMonth.month()) {
    return (
      <button disabled={true} className="date prev-month">
        {dateToRender.date()}
      </button>
    )
  }

  if (dateToRender.month() > dateOfMonth.month()) {
    return (
      <button disabled={true} className="date next-month">
        {dateToRender.date()}
      </button>
    )
  }

  return (
    <button
      className={`date in-month ${today} ${datesWithEvents.filter(dwe => String(dwe) === String(dateToRender.format('YYYY-MM-DD'))).length > 0 ? 'contains-event' : ''}`}
      onClick={() => props.onClick(dateToRender)}>
      {dateToRender.date()}
    </button>
  )
}

class Calendar extends React.Component {
  state = {
    calendar: undefined
  }

  componentDidMount() {
    this.setState({ calendar: createCalendar(this.props.date)})
  }

  componentDidUpdate(prevProps) {
    if (this.props.date !== prevProps.date) {
      this.setState({ calendar: createCalendar(this.props.date)})
    }
  }

  render() {
    if (!this.state.calendar) {
      return null
    }

    return (
      <div className="month">
        <div className="month-name">
          {this.state.calendar.currentDate.format('MMMM').toUpperCase()}
        </div>
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
          <span key={index} className="day">
            {day}
          </span>
        ))}
        {this.state.calendar.map((week, index) => (
          <div key={index}>
            {week.map(date => (
                <CalendarDate
                  events={this.props.events}
                  key={date.date()}
                  dateToRender={date}
                  dateOfMonth={this.state.calendar.currentDate}
                  onClick={date =>{
                    debugger;
                    this.props.setView(Views.MONTH);
                    this.props.setDate(date)
                    // alert(`Will go to daily-view of ${date.format('YYYY-MM-DD')}`)
                  }
                  }
                />
            ))}
          </div>
        ))}
      </div>
    )
  }
}

class Year extends React.Component {
  render() {
    let { date, events, ...props } = this.props
    console.log(this.props)
    let range = Year.range(date)
    const months = []
    
    const firstMonth = dates.startOf(date, 'year')

    for (let i = 0; i < 12; i++) {
      months.push(
        <Calendar key={i + 1} date={dates.add(firstMonth, i, 'month')} events={events} setView={this.props.setView} setDate={this.props.setDate}/>
      )
    }

    return <div className="year">{months.map(month => month)}</div>
  }
}

// Day.propTypes = {
//   date: PropTypes.instanceOf(Date).isRequired,
// }

Year.range = date => {
  return [dates.startOf(date, 'year')]
}

Year.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return dates.add(date, -1, 'year')

    case navigate.NEXT:
      return dates.add(date, 1, 'year')

    default:
      return date
  }
}

Year.title = (date, { localizer }) => moment.isMoment(date) ? `Year ${date.year()}` : `Year ${date.getFullYear()}`

export default Year
